<template lang="pug">
  div
    section.content-header
      h1 操作ログ
      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active 操作ログ

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      form(@submit.prevent="")
        mixin btnbar
          .bcard-btnbar.clearfix(class!=attributes.class)
            .pull-left
              router-link.btn.btn-default(:to="{name: 'admin'}", title="戻る"): i.fa.fa-reply
            .pull-right
              app-pagination(:is-loading="loadingPagination", :pagination="pagination", @change="getList")

        +btnbar

        .box.box-widget
          .box-header.with-border
            .box-title 検索条件
          .box-body
            .row
              .form-group.col-xs-6
                label 操作日時
                .input-group
                  date-picker.form-control(
                    name="date_from",
                    v-model="conds.datetime_from",
                    data-testid="-input-date_from",
                    :defaultDate="setDefaultDate ? default_conds_date_from : null"
                  )
                  span.input-group-addon ～
                  date-picker.form-control(
                    name="date_to",
                    v-model="conds.datetime_to",
                    data-testid="-input-date_to"
                  )

            .form-group
              label 操作内容
              .checkbox.checkbox-rich
                label.text-nowrap
                  input(type="checkbox" v-model="conds.categories" value="a")
                  span: i.fa.fa-check.fa-lg
                  | 名刺一覧の閲覧
                label.text-nowrap
                  input(type="checkbox" v-model="conds.categories" value="b")
                  span: i.fa.fa-check.fa-lg
                  | 名刺詳細の閲覧
              .checkbox.checkbox-rich
                label.text-nowrap
                  input(type="checkbox" v-model="conds.categories" value="c")
                  span: i.fa.fa-check.fa-lg
                  | 名刺情報のインポート
                label.text-nowrap
                  input(type="checkbox" v-model="conds.categories" value="d")
                  span: i.fa.fa-check.fa-lg
                  | 名刺情報のエクスポート

            .form-group
              label 操作ユーザー
              .form-control-static
                sel-users(
                  v-model="target_user",
                  input-name="target_user[]",
                  :view_mode="false",
                  :max-select="1"
                )
                .help-block
                  p.bcard-comments.text-info ※ 選択したユーザーの操作ログを検索します。

              label 代理操作ユーザー
              .form-control-static
                sel-users(
                  v-model="login_user",
                  input-name="login_user[]",
                  :view_mode="false",
                  :max-select="1"
                )
                .help-block
                  p.bcard-comments.text-info ※ 選択したユーザーが、操作ユーザーに成り代わって操作したログを検索します。

            .bcard-btnbar.text-right
              button.btn.btn-primary(type="button" @click.prevent="search") 検索
              |
              |
              router-link.btn.btn-default(:to="{name: 'AccessLog', params: {init: true}}") リセット

        .panel.panel-default
          loading(v-if="isLoading")
          .table-responsive(v-else-if="list.length > 0")
            table.table.table-striped.table-bordered.bcard-table
              thead
                tr
                  th.-thd-datetime 操作日時
                    i.fa.fa-sort-desc.bcard-table-sort-header-icon
                  th.-thd-category 操作内容
                  th.-thd-user 操作ユーザー（代理操作ユーザー）
                  th.-thd-func ダウンロード
              tbody
                tr(v-for="item in list", :key="item.id")
                  td {{item.formatted_datetime}}
                  td
                    router-link(:to="{name: 'AccessLogDetails', params: {id: '' + item.id}}") {{item.lang_category}}
                  td {{item.target_user.full_name}}
                    span(v-if="item.login_user") &nbsp;(代理: {{item.login_user.full_name}})
                  td
                    button.btn.btn-success.btn-sm(v-if="item.lang_category === '名刺情報のエクスポート'" type="button" @click="download(item.id)")
                      i.fa.fa-fw.fa-download
                      |
                      |
                      | エクスポートファイル
                    button.btn.btn-success.btn-sm(v-if="item.lang_category === '名刺情報のインポート'" type="button" @click="download(item.id)")
                      i.fa.fa-fw.fa-download
                      |
                      |
                      | インポートファイル

          .panel-body.text-center(v-else) 操作ログはありません。

      +btnbar

</template>

<script>
import mixinList from '@/mixins/list'
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import AppPagination from '@/components/molecules/AppPagination'
import Loading from '@/components/molecules/Loading'
import FuncAccessLogDownload from './_FuncAccessLogDownload'
import DatePicker from '@/components/molecules/DatePicker'
import SelUsers from '@/components/organisms/SelUsers'

export default {
  name: 'AccessLogDownload',
  components: { AppModal, AppMessages, AppPagination, Loading, FuncAccessLogDownload, DatePicker, SelUsers },
  mixins: [ mixinList ],
  data () {
    return {
      isLoading: true, // 読み込み中かどうか
      isDownloading: false, // ダウンロード中
      loadingPagination: true,
      conds: {
        page: 1,
        datetime_from: '',
        datetime_to: '',
        categories: [],
        target_user_id: null,
        login_user_id: null
      },

      // 検索条件
      target_user: null,
      login_user: null,

      // 検索範囲をデフォルトで絞って検索を軽くしておく（1ヶ月前～）
      default_conds_date_from: '-1m',
      setDefaultDate: true,

      // 検索済みフラグ
      isSearched: false
    }
  },
  created () {
    // サイドメニューから遷移した場合
    if (this.$route.params.init) {
      this.getList({page: 1})
    }
    else {
      // 検索結果を復元する
      this.isSearched = true
      this.setDefaultDate = false
      this.inputSearchConds()
      this.getList({page: this.pagination.current_page || 1})
    }
  },
  methods: {
    search: function () {
      // 検索結果をクリアする
      this.isSearched = false
      this.getList({page: 1})
    },
    reload () {
      this.getList({page: this.pagination.current_page || 1})
    },
    /**
     * 一覧取得処理
     * @param {object} options
     *  page: ページ番号
     */
    getList (options) {
      const vm = this
      options = options || {}
      // API実行
      vm.isLoading = true
      vm.loadingPagination = !options.viaPagination

      let params = {}
      // 初期値
      if (!vm.isSearched) {
        vm.conds = {
          page: options.page || 1,
          datetime_from: vm.conds.datetime_from,
          datetime_to: vm.conds.datetime_to,
          categories: vm.conds.categories,
          target_user_id: vm.target_user ? vm.target_user.id : null,
          login_user_id: vm.login_user ? vm.login_user.id : null
        }
        params = vm.conds
      }
      else {
        params = {
          page: options.page || 1,
          datetime_from: vm.conditions.datetime_from || null,
          datetime_to: vm.conditions.datetime_to || null,
          categories: vm.conditions.categories || null,
          target_user_id: vm.conditions.target_user_id || null,
          login_user_id: vm.conditions.login_user_id || null
        }
      }

      this.sendListRequest({
        repo: 'accesslogs',
        method: 'postSearch',
        params,
        onSuccess (response) {
          const data = vm.getApiData(response)
          vm.list = data.data
          vm.pagination = data.pagination
          vm.isLoading = false
          vm.loadingPagination = false

          // 変換前のデータを保存する
          vm.saveConds()
        },
        finally () {
          vm.isLoading = false
          vm.loadingPagination = false
        }
      })
    },
    /**
     * 復元したいデータを保存する
     */
    saveConds: function () {
      // 変換前のデータを追加する
      this.conditions.target_user = this.target_user
      this.conditions.login_user = this.login_user

      this.$store.commit('setSearchConds', {
        target: '',
        data: {
          pagination: this.pagination,
          conditions: this.conditions
        }
      })
    },
    /**
     * 前回の検索条件を入力した状態にする
     */
    inputSearchConds: function () {
      this.conds.page = this.pagination
      this.conds.datetime_from = this.conditions.datetime_from || null
      this.conds.datetime_to = this.conditions.datetime_to || null
      this.conds.categories = this.conditions.categories || null
      this.target_user = this.$store.getState('searchConds').conditions.target_user || null
      this.login_user = this.$store.getState('searchConds').conditions.login_user || null
    },
    /**
     * 実ファイルダウンロード
     * @param id 操作ログID
     */
    download: function (id) {
      const vm = this
      // ダウンロード中ではない場合のみ実行する
      if (this.isDownloading === false) {
        this.isDownloading = true

        this.getFileDL('accesslogs', 'logDownload', 'access_log_' + id + '.csv', id)
          .catch(function (error) {
            vm.setErrorMessage(error)
          })
          .finally(function () {
            vm.isDownloading = false
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .checkbox.checkbox-rich label {
    width: 200px;
  }
  .-thd-datetime { width: 200px; }
  .-thd-category { width: auto; }
  .-thd-user { width: auto; }
  .-thd-func { width: 200px; }
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/accesslog/List.vue